import useLogoutHandler from "@/hooks/useLogoutHandler";
import useAppQueryParam from "@/hooks/useAppQueryParam";
import { useEffect } from "react";

const useLogoutParam = () => {
  const { getQueryParam } = useAppQueryParam();
  const { handleLogout } = useLogoutHandler();
  const shouldLogout = getQueryParam("logout") === "true";

  useEffect(() => {
    if (shouldLogout) {
      handleLogout();
    }
  }, [shouldLogout, handleLogout]);
};

export default useLogoutParam;
